import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/features/IconComponent.vue";
import {KycProgressStatus, KycStepInfo, KycStepName} from "@/models/user/kyc";


export default /*#__PURE__*/_defineComponent({
  __name: 'KycTier',
  props: {
    header: { type: String, required: true },
    description: { type: String, required: true },
    listOfSteps: { type: Array, required: true },
    tier: { type: Number, required: true }
  },
  emits: ['verify'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;
const getStepName = (name: KycStepName): string => {
  if(name == KycStepName.ID_DOCUMENT)
    return 'Identity document';
  if(name == KycStepName.LIVENESS)
    return 'Personal information';
  if(name == KycStepName.PHONE)
    return 'Phone number';
  if(name == KycStepName.PROOF_OF_ADDRESS)
    return 'Proof of residency';
  return '';
};

const isVerified = (): boolean => {
  let verified = true;
  props.listOfSteps.forEach(step => {
    if(step.state != KycProgressStatus.APPROVED)
      verified = false;
  });
  return verified;
};

const onVerifyClick = () => {
  emit('verify', props.tier);
};

const __returned__ = { props, emit, getStepName, isVerified, onVerifyClick, Icon, get KycProgressStatus() { return KycProgressStatus } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})